var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-page"},[_c('div',{staticClass:"top-title"},[_vm._v("用电安全认知教学")]),_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/ele/1.jpg")}})]),_c('div',{staticClass:"text-content"},[_vm._v("\n    通过安全用电教学可以让施工人员充分了解和掌握安全用电常识、安全用电规范，触电原因、触电形式、触电急救的方法和安全用电工具的使用方法。\n  ")])])
}]

export { render, staticRenderFns }